__turbopack_context__.v({
  "container": "favorites-module-scss-module__ByDSEq__container",
  "header": "favorites-module-scss-module__ByDSEq__header",
  "headerIcon": "favorites-module-scss-module__ByDSEq__headerIcon",
  "inner": "favorites-module-scss-module__ByDSEq__inner",
  "noResults": "favorites-module-scss-module__ByDSEq__noResults",
  "root": "favorites-module-scss-module__ByDSEq__root",
});
